'use strict';

exports.__esModule = true;
exports.poolingAcknowledgement = poolingAcknowledgement;
exports.failCollection = failCollection;

var _apiClient = require('../../network/api-client');

var _apiClient2 = _interopRequireDefault(_apiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API = {
  COURIER_ORDER_POOLINGACKNOWLEDGEMENT: function COURIER_ORDER_POOLINGACKNOWLEDGEMENT(orderId) {
    return '/courier/orders/' + orderId + '/pooling_acknowledgement';
  },
  COURIER_ORDER_FAIL_COLLECTION: '/courier/orders/set_collection_failed'

  /**
   * Wrapper for `/courier/orders` API endpoint
   */
};var orders = {
  poolingAcknowledgement: poolingAcknowledgement,
  failCollection: failCollection
};

exports.default = orders;

/**
 * Acknowledge order pooled into mission
 * @orderId {Number} The id of the order
 * @returns {promise} with response/errors
 */

function poolingAcknowledgement(orderId) {
  return _apiClient2.default.put({ route: API.COURIER_ORDER_POOLINGACKNOWLEDGEMENT(orderId), data: { orderId: orderId } });
}

/**
 * Fail a collection mission
 * @orderIds {Array} a list of client order ids
 * @failureReason {String} the failure reason selected
 * @failureReasonUid {Number} the selected failure reason's uid
 * @returns {promise} with response/errors
 */
function failCollection(_ref) {
  var orderIds = _ref.orderIds,
      deliveryFailureReason = _ref.deliveryFailureReason,
      deliveryFailureReasonUid = _ref.deliveryFailureReasonUid;

  var data = {
    order_ids: orderIds,
    failure_reason: deliveryFailureReason,
    failure_reason_uid: deliveryFailureReasonUid
  };
  return _apiClient2.default.put({ route: API.COURIER_ORDER_FAIL_COLLECTION, data: data });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/courier/orders/orders.js
// module id = 1188
// module chunks = 0